<template>
  <div style="overflow: hidden">
    <template>
      <vs-row class="mt-5" v-if="!showRegisterPopup">
        <vs-col vs-justify="center" vs-align="center" vs-w="12">
          لطفا شماره همراه کارمند خود را وارد نمایید:
          <vs-input v-model="employeePhone" class="w-100 mt-1" maxlength="11" />
          <vs-button
            @click="createUser()"
            class="mt-5"
            color="secondary"
            block
            icon-pack="feather"
            icon="icon-check"
            >ثبت
          </vs-button>
        </vs-col>
      </vs-row>

      <div v-if="showRegisterPopup">
        <vs-col vs-w="12" class="mb-6">
          <div class="flex items-center flex-col">
            <h5 class="mb-3">پروفایل کارمند در سیستم تکمیل نشده است.</h5>
            <p>
              میتوانید پروفایل کارمند خود را تکمیل کنید در غیراینصورت دکمه ادامه
              را بزنید.
            </p>
          </div>
        </vs-col>

        <vs-col vs-w="6" vs-xs="12" class="mb-5">
          شماره همراه کارمند:
          <vs-input
            v-model="employeePhone"
            placeholder="شماره همراه کارمند"
            class="w-100 mt-1"
            disabled
          />
        </vs-col>
        <vs-col vs-w="6" vs-xs="12" class="mb-5">
          نام کارمند:
          <vs-input
            v-model="employeeName"
            placeholder="نام کارمند"
            class="w-100 mt-1"
          />
        </vs-col>

        <vs-col vs-sm="12" vs-lg="6" class="mb-0 mt-5">
          <vs-button
            @click="skipRegister"
            class="w-full font-bold"
            color="secondary"
            type="border"
          >
            ادامه
          </vs-button>
        </vs-col>
        <vs-col vs-sm="12" vs-lg="6" class="mb-0 mt-5">
          <vs-button @click="registerUser" class="w-full" color="secondary">
            تکمیل پروفایل
          </vs-button>
        </vs-col>
      </div>
    </template>
  </div>
</template>

<script>
import FetchError from "../../services/api/FetchError";
import { mapGetters } from "vuex";
import providerApiService from "../../services/api/ProviderApiService";

export default {
  name: "AddEmployee",
  data() {
    return {
      employeePhone: this.value?.phone,
      employeeName: "",
      user: null,
      error: null,
      loading: false,
      dashboardAccessId: 9,
      FetchError,
      Blob: window.Blob,
      showRegisterPopup: false,
    };
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  methods: {
    createUser() {
      if (this.employeePhone.length !== 11) {
        this.$vs.notify({
          text: "شماره تلفن را به درستی وارد کنید.",
          position: "bottom-center",
          color: "warning",
        });
        return;
      }

      this.addEmployee(this.employeePhone);
    },
    addEmployee(phone) {
      this.$vs.loading();
      providerApiService
        .addEmployee(this.currentProvider.id, phone)
        .then((result) => {
          this.user = result.resource;
          if (!this.user.name) {
            this.showRegisterPopup = true;
          } else {
            this.$emit("employeeCreated", this.user);
          }
        })
        .catch(this.requestFailed)
        .finally(() => this.$vs.loading.close());
    },
    requestFailed(error) {
      this.$vs.notify({
        text: error.error.error
          ? error.error.error.response.data.message
          : error.error.response.data.message,
        position: "bottom-center",
        color: "danger",
      });
      this.$vs.loading.close();
    },
    registerUser() {
      if (this.employeeName) {
        this.user = {
          ...this.user,
          name: this.employeeName,
        };
      }

      this.$vs.loading();
      providerApiService
        .registerUser(this.currentProvider.id, this.user)
        .then((result) => {
          this.$emit("employeeCreated", result.data);
        })
        .finally(() => this.$vs.loading.close());
    },
    skipRegister() {
      this.$emit("employeeCreated", this.user);
    },
  },
  props: {
    value: {
      type: Object,
    },
    createMode: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
